import { prefixes, prependIntlIds } from "../utils";

export const unprefixedHegMappingMessages = {
  username: "Uživatelské jméno",
  login: "login",
  password: "Heslo",

  change_mapping: "Změnit mapování",
  submit: "Nastavit",

  map_user_to_datasource: "Mapování uživatele na {datasourceName}",
} as const;

export default prependIntlIds(
  prefixes.hegMapping,
  unprefixedHegMappingMessages
);
